/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useSignInFlowType } from '@/components/SignInFlowTypeContext';
import { countryCodes } from '@/constants/locale';
import { useLoginConfirmation } from '@/features/account/hooks/useLoginConfirmation';
import { STAND_ALONE_USER_TYPE } from '@/features/header';
import { useMyProfile } from '@/features/myProfile/api/getMyProfileV2';
import { useLocale } from '@/hooks/useLocale';
import { localStorage } from '@/utils/localStorage';
import { useEffect } from 'react';
import { sessionStorage } from '@/utils/sessionStorage';

export const useAccountTypeModal = () => {
  const locale = useLocale();
  const { data: profile } = useMyProfile();
  const { showRewardSigninPopup } = useLoginConfirmation();
  const { flowType } = useSignInFlowType();
  const isUS = locale === countryCodes.us;

  const storedHideModal = localStorage.getItem('hideModal') === 'true';
  const hideSessionRewardsModal = sessionStorage.getItem('hideRewardsModal') === 'true';

  useEffect(() => {
    const userType = profile?.userType;
    const isStandAloneUser = userType === Number(STAND_ALONE_USER_TYPE);
    if (
      isStandAloneUser &&
      !storedHideModal &&
      flowType !== 'forgotPassword' &&
      isUS &&
      !hideSessionRewardsModal
    ) {
      showRewardSigninPopup();
    }
  }, [
    storedHideModal,
    showRewardSigninPopup,
    profile?.userType,
    flowType,
    isUS,
    hideSessionRewardsModal,
  ]);
};
